import React, { FC } from 'react'
import { getProductCategoryPagination } from 'lib/category'
import styles from './ResultsCount.module.scss'
import { capitalizeString } from 'lib-ts/helpers'

type ResultsCountProps = {
  hitsTotal: number
  hitsPerPage: number
  category?: string
  currentPage: number
}

const ResultsCount: FC<ResultsCountProps> = (props) => {
  const { hitsTotal, hitsPerPage, category, currentPage } = props
  const displayCategory = category ? capitalizeString(getProductCategoryPagination(category)) : ''

  if (!hitsTotal) {
    return null
  }

  return (
    <div className={styles.resultsCount} data-type='results-count'>
      {hitsTotal < hitsPerPage ? (
        <p>{!hitsTotal ? 'No Results' : `1 - ${hitsTotal} ${displayCategory}`}</p>
      ) : (
        <p>
          {(hitsPerPage * currentPage + 1).toLocaleString()} -{' '}
          {hitsTotal < hitsPerPage * (currentPage + 1)
            ? `${hitsTotal.toLocaleString()} ${displayCategory}` // 26-29
            : `${(
                hitsPerPage *
                (currentPage + 1)
              ).toLocaleString()} of ${hitsTotal.toLocaleString()} ${displayCategory}`}
        </p>
      )}
    </div>
  )
}

export default ResultsCount
